var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_3284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0835 5.83594V12.8359",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 3.4274L8.1665 5.83073H11.5673C11.7485 5.83073 11.9271 5.8729 12.0891 5.9539C12.2511 6.0349 12.392 6.1525 12.5007 6.2974C12.6093 6.44229 12.6828 6.6105 12.7152 6.7887C12.7476 6.96689 12.7381 7.15019 12.6873 7.32406L11.3282 11.9907C11.2575 12.2331 11.1101 12.4459 10.9082 12.5974C10.7062 12.7489 10.4606 12.8307 10.2082 12.8307H2.33317C2.02375 12.8307 1.72701 12.7078 1.50821 12.489C1.28942 12.2702 1.1665 11.9735 1.1665 11.6641V6.9974C1.1665 6.68798 1.28942 6.39123 1.50821 6.17244C1.72701 5.95365 2.02375 5.83073 2.33317 5.83073H3.94317C4.16022 5.83061 4.37293 5.76995 4.55739 5.65557C4.74186 5.54118 4.89075 5.3776 4.98734 5.18323L6.99984 1.16406C7.27492 1.16747 7.54568 1.23299 7.79189 1.35574C8.03809 1.47849 8.25338 1.65529 8.42166 1.87293C8.58993 2.09057 8.70686 2.34342 8.76368 2.6126C8.82051 2.88177 8.81578 3.16031 8.74984 3.4274Z",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_3284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.5de089020f97b1e4e5bd86faafdc7ef9.svg";
export { ForwardRef as ReactComponent };